import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { rememberAccountIntent } from '../utils/accountIntent';
import { recordFunnelEvent } from '../utils/siteStats';
import { hasSignedInBefore, mockAuthHref } from '../utils/authMemory';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const [state, setState] = useState(() => (auth.currentUser ? 'authed' : 'loading'));
  const trackedPath = useRef('');
  const guestMock = location.pathname.replace(/\/$/, '') === '/quiz/session-1';

  useEffect(() => onAuthStateChanged(auth, (user) => setState(user ? 'authed' : 'anon')), []);

  useEffect(() => {
    if (guestMock || state !== 'anon' || trackedPath.current === location.pathname) return;
    trackedPath.current = location.pathname;
    rememberAccountIntent('mock_access_intent', {
      targetPath: `${location.pathname}${location.search}`,
      source: 'auth_gate',
    });
    recordFunnelEvent('mock_auth_required').catch(() => {});
    recordFunnelEvent(`mock_auth_required__${hasSignedInBefore() ? 'returning' : 'new'}`).catch(() => {});
  }, [state, location.pathname, location.search, guestMock]);

  if (guestMock) return children;

  if (state === 'loading') {
    return (
      <div className="exam-loading">
        <div className="exam-intro-card">
          <div className="exam-kicker">Account check</div>
          <h1>Preparing your mock…</h1>
          <p className="meta">Verifying your sign-in so this sitting can be saved.</p>
        </div>
      </div>
    );
  }

  if (state === 'anon') {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={mockAuthHref(next)} replace />;
  }

  return children;
}
